export enum OtpChannel {
  email = 'email',
  phone = 'phone'
}
